// extracted by mini-css-extract-plugin
module.exports = {"messageDetails":"MessageDetails_messageDetails__3oxLM","timestamp":"MessageDetails_timestamp__3JmuO","status":"MessageDetails_status__1fOAL"};